"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteConfigurationBuilder = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const Kette_1 = require("./Kette");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const KetteValidator_1 = require("./KetteValidator");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const RolEchainCalculatorFactory_1 = require("../rolEchain/RolEchainCalculatorFactory");
/**
 * The `KetteConfigurationBuilder` populates a Kette so that it validates for a configuration
 */
class KetteConfigurationBuilder {
    constructor() {
        this.className = 'KetteConfigurationBuilder';
    }
    /**
     * Validates and sets calculated Kette properties based on Laenge (L)
     */
    buildByLaenge(kette, laenge) {
        kette.lengthCalcInitializedBy = echain_shared_articles_1.KetteLengthCalcInitializedBy.laenge;
        echain_shared_validation_1.Validation.throws([KetteValidator_1.KetteValidator.langerWegConsistency(kette), KetteValidator_1.KetteValidator.einspeisungConsistency(kette)]);
        kette.laenge = laenge;
        switch (kette.serieType) {
            case echain_shared_articles_1.KetteSerieType.twisterband:
            case echain_shared_articles_1.KetteSerieType.trxe:
                // nothing to do already on data
                break;
            case echain_shared_articles_1.KetteSerieType.triflexR:
            case echain_shared_articles_1.KetteSerieType.twisterchain:
            case echain_shared_articles_1.KetteSerieType.rxRohr:
            case echain_shared_articles_1.KetteSerieType.default:
            case echain_shared_articles_1.KetteSerieType.eskin:
                kette.numGlieder = KetteConfigurationBuilder.calcNumGlieder(kette);
                // calcEffektiveLaenge needs numGlieder to be calculated beforehand
                kette.effektiveLaenge = KetteConfigurationBuilder.calcEffektiveLaenge(kette);
                break;
            case echain_shared_articles_1.KetteSerieType.rolEchain:
                throw new Error(`${this.className}.buildByLaenge() does not support ${kette.serieType}`);
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(kette.serieType);
        }
        switch (kette.serieType) {
            case echain_shared_articles_1.KetteSerieType.eskin:
                kette.verfahrweg = KetteConfigurationBuilder.calcESkinVerfahrweg(kette);
                break;
            case echain_shared_articles_1.KetteSerieType.triflexR:
            case echain_shared_articles_1.KetteSerieType.trxe:
            case echain_shared_articles_1.KetteSerieType.twisterband:
            case echain_shared_articles_1.KetteSerieType.twisterchain:
                // do nothing since we cannot calc it
                break;
            case echain_shared_articles_1.KetteSerieType.rxRohr:
            case echain_shared_articles_1.KetteSerieType.default:
                kette.verfahrweg = KetteConfigurationBuilder.calcVerfahrweg(kette);
                break;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(kette.serieType);
        }
    }
    /**
     * Validates and sets calculated KetteJson properties based on Laenge (L)
     *
     * @param ketteJson
     * @param laenge
     */
    buildByLaengeJson(ketteJson, laenge) {
        ketteJson.LengthCalcInitializedBy = echain_shared_articles_1.KetteLengthCalcInitializedBy.laenge;
        echain_shared_validation_1.Validation.throws([
            KetteValidator_1.KetteValidator.langerWegConsistencyJson(ketteJson),
            KetteValidator_1.KetteValidator.einspeisungConsistencyJson(ketteJson),
        ]);
        ketteJson.Laenge = laenge.toJson();
        if (ketteJson.KetteSerieType) {
            switch (ketteJson.KetteSerieType) {
                case echain_shared_articles_1.KetteSerieType.twisterband:
                    // twisterband has already EffektiveLaenge and NumGlieder on data
                    break;
                case echain_shared_articles_1.KetteSerieType.default:
                case echain_shared_articles_1.KetteSerieType.rolEchain:
                case echain_shared_articles_1.KetteSerieType.trxe:
                case echain_shared_articles_1.KetteSerieType.twisterchain:
                case echain_shared_articles_1.KetteSerieType.triflexR:
                case echain_shared_articles_1.KetteSerieType.eskin:
                case echain_shared_articles_1.KetteSerieType.rxRohr:
                    ketteJson.NumGlieder = KetteConfigurationBuilder.calcNumGliederJson(ketteJson);
                    // calcEffektiveLaengeJson needs numGlieder to be calculated beforehand
                    ketteJson.EffektiveLaenge = KetteConfigurationBuilder.calcEffektiveLaengeJson(ketteJson).toJson();
                    break;
                default:
                    (0, echain_shared_ts_utils_1.assertUnreachable)(ketteJson.KetteSerieType);
            }
        }
        if (echain_shared_articles_1.KetteJsonUtil.hasStandardVerfahrwegCalculation(ketteJson)) {
            ketteJson.Verfahrweg = KetteConfigurationBuilder.calcVerfahrwegJson(ketteJson).toJson();
            return;
        }
        const type = ketteJson.KetteSerieType;
        switch (type) {
            case echain_shared_articles_1.KetteSerieType.eskin:
                ketteJson.Verfahrweg = KetteConfigurationBuilder.calcESkinVerfahrwegJson(ketteJson).toJson();
                break;
            // do nothing since we cannot calc it
            case echain_shared_articles_1.KetteSerieType.default:
            case echain_shared_articles_1.KetteSerieType.rxRohr:
            case undefined:
            case echain_shared_articles_1.KetteSerieType.triflexR:
            case echain_shared_articles_1.KetteSerieType.trxe:
            case echain_shared_articles_1.KetteSerieType.twisterband:
            case echain_shared_articles_1.KetteSerieType.twisterchain:
            case echain_shared_articles_1.KetteSerieType.rolEchain:
                return;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
    }
    /**
     * Validates and sets calculated Kette properties based on Verfahrweg (S)
     *
     * @param kette
     * @param verfahrweg
     */
    buildByVerfahrweg(kette, verfahrweg) {
        kette.lengthCalcInitializedBy = echain_shared_articles_1.KetteLengthCalcInitializedBy.verfahrweg;
        echain_shared_validation_1.Validation.throws([KetteValidator_1.KetteValidator.langerWegConsistency(kette), KetteValidator_1.KetteValidator.einspeisungConsistency(kette)]);
        kette.verfahrweg = verfahrweg;
        switch (kette.serieType) {
            case echain_shared_articles_1.KetteSerieType.triflexR:
            case echain_shared_articles_1.KetteSerieType.trxe:
            case echain_shared_articles_1.KetteSerieType.twisterband:
            case echain_shared_articles_1.KetteSerieType.twisterchain:
                throw new Error(`${this.className}.buildByVerfahrweg() does not support ${kette.serieType}`);
            case echain_shared_articles_1.KetteSerieType.rxRohr:
            case echain_shared_articles_1.KetteSerieType.default:
                kette.laenge = KetteConfigurationBuilder.calcLaenge(kette);
                kette.numGlieder = KetteConfigurationBuilder.calcNumGlieder(kette);
                kette.effektiveLaenge = KetteConfigurationBuilder.calcEffektiveLaenge(kette);
                kette.laenge = echain_shared_quantities_1.Length.mm(kette.effektiveLaenge.mm);
                break;
            case echain_shared_articles_1.KetteSerieType.eskin:
                kette.laenge = KetteConfigurationBuilder.calcESkinLaenge(kette);
                kette.numGlieder = KetteConfigurationBuilder.calcNumGlieder(kette);
                kette.effektiveLaenge = KetteConfigurationBuilder.calcEffektiveLaenge(kette);
                kette.laenge = echain_shared_quantities_1.Length.mm(kette.effektiveLaenge.mm);
                break;
            case echain_shared_articles_1.KetteSerieType.rolEchain: {
                const rolEchain = kette.toModel();
                if (!(0, echain_shared_articles_1.isCalculateableRolEchain)(rolEchain)) {
                    throw new Error(`${this.className}.buildByVerfahrweg() rolEchain is not calculateable`);
                }
                const calculator = RolEchainCalculatorFactory_1.RolEchainCalculatorFactory.getCalculator(rolEchain);
                kette.laenge = calculator.calcLaenge(rolEchain);
                kette.effektiveLaenge = kette.laenge.clone();
                kette.numGlieder = calculator.calcTotalNumLinks(rolEchain);
                // set the `gewichtKgProM` for RolEchains here since it depends on the `Laenge`.
                kette.gewichtKgProM = echain_shared_quantities_1.WeightPerLength.kg_m(calculator.calcTotalWeight(rolEchain).kg / kette.laenge.m);
                break;
            }
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(kette.serieType);
        }
    }
    /**
     * Validates and sets calculated KetteJson properties based on Verfahrweg (S)
     *
     * @param ketteJson
     * @param verfahrweg
     */
    buildByVerfahrwegJson(ketteJson, verfahrweg) {
        ketteJson.LengthCalcInitializedBy = echain_shared_articles_1.KetteLengthCalcInitializedBy.verfahrweg;
        echain_shared_validation_1.Validation.throws([
            KetteValidator_1.KetteValidator.langerWegConsistencyJson(ketteJson),
            KetteValidator_1.KetteValidator.einspeisungConsistencyJson(ketteJson),
        ]);
        ketteJson.Verfahrweg = verfahrweg.toJson();
        if (ketteJson.KetteSerieType === echain_shared_articles_1.KetteSerieType.eskin) {
            ketteJson.Laenge = KetteConfigurationBuilder.calcESkinLaengeJson(ketteJson).toJson();
        }
        else {
            ketteJson.Laenge = KetteConfigurationBuilder.calcLaengeJson(ketteJson).toJson();
        }
        ketteJson.NumGlieder = KetteConfigurationBuilder.calcNumGliederJson(ketteJson);
        ketteJson.EffektiveLaenge = KetteConfigurationBuilder.calcEffektiveLaengeJson(ketteJson).toJson();
        ketteJson.Laenge = Object.assign({}, ketteJson.EffektiveLaenge);
    }
    /**
     * Validates and sets calculated Kette properties based on number of Kettenglieder.
     * In this very special case, we assume that when the user defines the value for `numGlieder`,
     * the `laenge` is exactly the same value as `effektiveLaenge`.
     * This is somehow a trick,  so that we can perform calculations.
     *
     * @param kette
     * @param numGlieder
     */
    buildByNumGlieder(kette, numGlieder) {
        kette.lengthCalcInitializedBy = echain_shared_articles_1.KetteLengthCalcInitializedBy.numGlieder;
        echain_shared_validation_1.Validation.throws([KetteValidator_1.KetteValidator.langerWegConsistency(kette), KetteValidator_1.KetteValidator.einspeisungConsistency(kette)]);
        kette.numGlieder = KetteConfigurationBuilder.validateNumGlieder(kette, numGlieder);
        // 1. calc effektiveLange because its trivial
        kette.effektiveLaenge = KetteConfigurationBuilder.calcEffektiveLaenge(kette);
        // 2. set laenge so that we can calc verfahrweg
        kette.laenge = echain_shared_quantities_1.Length.mm(kette.effektiveLaenge.mm);
        // 3. calc verfahrweg so that we can calc laenge
        switch (kette.serieType) {
            case echain_shared_articles_1.KetteSerieType.eskin:
                kette.verfahrweg = KetteConfigurationBuilder.calcESkinVerfahrweg(kette);
                break;
            case echain_shared_articles_1.KetteSerieType.triflexR:
            case echain_shared_articles_1.KetteSerieType.trxe:
            case echain_shared_articles_1.KetteSerieType.twisterband:
            case echain_shared_articles_1.KetteSerieType.twisterchain:
                // do nothing since we cannot calc it
                break;
            case echain_shared_articles_1.KetteSerieType.rxRohr:
            case echain_shared_articles_1.KetteSerieType.default:
                kette.verfahrweg = KetteConfigurationBuilder.calcVerfahrweg(kette);
                break;
            case echain_shared_articles_1.KetteSerieType.rolEchain:
                throw new Error(`${this.className}.buildByNumGlieder() does not support ${kette.serieType}`);
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(kette.serieType);
        }
    }
    /**
     * Validates and sets calculated KetteJson properties based on number of Kettenglieder.
     * In this very special case, we assume that when the user defines the value for `numGlieder`.
     *
     * @param ketteJson
     * @param numGlieder
     */
    buildByNumGliederJson(ketteJson, numGlieder) {
        ketteJson.LengthCalcInitializedBy = echain_shared_articles_1.KetteLengthCalcInitializedBy.numGlieder;
        echain_shared_validation_1.Validation.throws([
            KetteValidator_1.KetteValidator.langerWegConsistencyJson(ketteJson),
            KetteValidator_1.KetteValidator.einspeisungConsistencyJson(ketteJson),
        ]);
        ketteJson.NumGlieder = KetteConfigurationBuilder.validateNumGliederJson(ketteJson, numGlieder);
        // 1. calc effektiveLange because its trivial
        ketteJson.EffektiveLaenge = KetteConfigurationBuilder.calcEffektiveLaengeJson(ketteJson).toJson();
        // 2. set laenge so that we can calc verfahrweg
        ketteJson.Laenge = Object.assign({}, ketteJson.EffektiveLaenge);
        // 3. calc verfahrweg so that we can calc laenge
        if (echain_shared_articles_1.KetteJsonUtil.hasStandardVerfahrwegCalculation(ketteJson)) {
            ketteJson.Verfahrweg = KetteConfigurationBuilder.calcVerfahrwegJson(ketteJson).toJson();
            return;
        }
        const type = ketteJson.KetteSerieType;
        switch (type) {
            case echain_shared_articles_1.KetteSerieType.eskin:
                ketteJson.Verfahrweg = KetteConfigurationBuilder.calcESkinVerfahrwegJson(ketteJson).toJson();
                break;
            // do nothing since we cannot calc it
            case echain_shared_articles_1.KetteSerieType.default:
            case echain_shared_articles_1.KetteSerieType.rxRohr:
            case undefined:
            case echain_shared_articles_1.KetteSerieType.triflexR:
            case echain_shared_articles_1.KetteSerieType.trxe:
            case echain_shared_articles_1.KetteSerieType.twisterband:
            case echain_shared_articles_1.KetteSerieType.twisterchain:
            case echain_shared_articles_1.KetteSerieType.rolEchain:
                return;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
    }
    /**
     * Resets calculated Kette properties to null
     */
    reset(kette) {
        kette.effektiveLaenge = undefined;
        kette.laenge = undefined;
        kette.numGlieder = undefined;
        kette.verfahrweg = undefined;
    }
    /**
     * Reruns last build method to recalculated values with updated properties
     */
    update(kette) {
        switch (kette.serieType) {
            case echain_shared_articles_1.KetteSerieType.twisterband:
            case echain_shared_articles_1.KetteSerieType.trxe:
                // just leave here, since we do not calculate anything, but we do not want to throw!
                return;
            case undefined:
            case echain_shared_articles_1.KetteSerieType.triflexR:
            case echain_shared_articles_1.KetteSerieType.twisterchain:
            case echain_shared_articles_1.KetteSerieType.rxRohr:
            case echain_shared_articles_1.KetteSerieType.default:
            case echain_shared_articles_1.KetteSerieType.eskin:
            case echain_shared_articles_1.KetteSerieType.rolEchain:
                break;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(kette.serieType);
        }
        if (kette.lengthCalcInitializedBy === echain_shared_articles_1.KetteLengthCalcInitializedBy.laenge) {
            if (!kette.laenge) {
                throw new Error(`${this.className}.update: Invalid kette.laenge`);
            }
            this.buildByLaenge(kette, kette.laenge);
        }
        else if (kette.lengthCalcInitializedBy === echain_shared_articles_1.KetteLengthCalcInitializedBy.verfahrweg) {
            if (!kette.verfahrweg) {
                throw new Error(`${this.className}.update: Invalid kette.verfahrweg`);
            }
            this.buildByVerfahrweg(kette, kette.verfahrweg);
        }
        else if (kette.lengthCalcInitializedBy === echain_shared_articles_1.KetteLengthCalcInitializedBy.numGlieder) {
            if (!kette.numGlieder) {
                throw new Error(`${this.className}.update: Invalid kette.laenge`);
            }
            this.buildByNumGlieder(kette, kette.numGlieder);
        }
        else {
            echain_shared_validation_1.Validation.throws('Update method ' + kette.lengthCalcInitializedBy + ' not known!');
        }
    }
    /*******************************************************************************************
     * todo the whole lower part of this class should be moved to KetteCalculator
     */
    static calcEffektiveLaenge(kette) {
        if (!kette.numGlieder) {
            throw new Error(`KetteConfigurationBuilder.calcEffektiveLaenge: Invalid kette.numGlieder`);
        }
        if (!kette.teilung) {
            throw new Error(`KetteConfigurationBuilder.calcEffektiveLaenge: Invalid kette.teilung`);
        }
        return echain_shared_articles_1.KetteCalculator.calcEffektiveLaenge(kette.numGlieder, kette.teilung);
    }
    static calcEffektiveLaengeJson(ketteJson) {
        if (!ketteJson.NumGlieder) {
            throw new Error(`KetteConfigurationBuilder.calcEffektiveLaengeJson: Invalid ketteJson.NumGlieder`);
        }
        if (!ketteJson.Teilung) {
            throw new Error(`KetteConfigurationBuilder.calcEffektiveLaengeJson: Invalid ketteJson.Teilung`);
        }
        const teilung = echain_shared_quantities_1.Length.fromJson(ketteJson.Teilung);
        return echain_shared_articles_1.KetteCalculator.calcEffektiveLaenge(ketteJson.NumGlieder, teilung);
    }
    static calcLaenge(kette) {
        if (!kette.verfahrweg) {
            throw new Error(`KetteConfigurationBuilder.calcLaenge: Invalid kette.verfahrweg`);
        }
        if (kette.langerWeg) {
            if (!kette.k2) {
                throw new Error(`KetteConfigurationBuilder.calcLaenge: Invalid kette.k2`);
            }
            return echain_shared_articles_1.KetteCalculator.calcLaengeWithLangerWeg(kette.verfahrweg, kette.k2, kette.versatz);
        }
        if (!kette.k) {
            throw new Error(`KetteConfigurationBuilder.calcLaenge: Invalid kette.k`);
        }
        return echain_shared_articles_1.KetteCalculator.calcLaenge(kette.verfahrweg, kette.k, kette.versatz);
    }
    static calcESkinLaenge(kette) {
        if (!kette.verfahrweg) {
            throw new Error(`KetteConfigurationBuilder.calcESkinLaenge: Invalid kette.verfahrweg`);
        }
        if (!kette.k) {
            throw new Error(`KetteConfigurationBuilder.calcESkinLaenge: Invalid kette.k`);
        }
        const aeExcessLength = kette.getESkinAeExcessLength();
        return echain_shared_articles_1.KetteCalculator.calcESkinLaenge(kette.verfahrweg, kette.k, aeExcessLength, kette.versatz);
    }
    static calcLaengeJson(ketteJson) {
        if (!ketteJson.Verfahrweg) {
            throw new Error(`KetteConfigurationBuilder.calcLaengeJson: Invalid ketteJson.Verfahrweg`);
        }
        const verfahrweg = echain_shared_quantities_1.Length.fromJson(ketteJson.Verfahrweg);
        const versatz = ketteJson.Versatz ? echain_shared_quantities_1.Length.fromJson(ketteJson.Versatz) : echain_shared_quantities_1.Length.mm(0);
        if (ketteJson.LangerWeg) {
            if (!ketteJson.Verfahrweg) {
                throw new Error(`KetteConfigurationBuilder.calcLaengeJson: Invalid ketteJson.Verfahrweg`);
            }
            if (!ketteJson.K2) {
                throw new Error(`KetteConfigurationBuilder.calcLaengeJson: Invalid ketteJson.K2`);
            }
            const k2 = echain_shared_quantities_1.Length.fromJson(ketteJson.K2);
            return echain_shared_articles_1.KetteCalculator.calcLaengeWithLangerWeg(verfahrweg, k2, versatz);
        }
        else {
            if (!ketteJson.K) {
                throw new Error(`KetteConfigurationBuilder.calcLaengeJson: Invalid ketteJson.K`);
            }
            const k = echain_shared_quantities_1.Length.fromJson(ketteJson.K);
            return echain_shared_articles_1.KetteCalculator.calcLaenge(verfahrweg, k, versatz);
        }
    }
    static calcESkinLaengeJson(ketteJson) {
        if (!ketteJson.Verfahrweg) {
            throw new Error(`KetteConfigurationBuilder.calcESkinLaengeJson: Invalid ketteJson.Verfahrweg`);
        }
        if (!ketteJson.K) {
            throw new Error(`KetteConfigurationBuilder.calcLaengeJson: Invalid ketteJson.K`);
        }
        const verfahrweg = echain_shared_quantities_1.Length.fromJson(ketteJson.Verfahrweg);
        const versatz = ketteJson.Versatz ? echain_shared_quantities_1.Length.fromJson(ketteJson.Versatz) : echain_shared_quantities_1.Length.mm(0);
        const k = echain_shared_quantities_1.Length.fromJson(ketteJson.K);
        const aeExcessLength = Kette_1.Kette.fromJson(ketteJson).getESkinAeExcessLength();
        return echain_shared_articles_1.KetteCalculator.calcESkinLaenge(verfahrweg, k, aeExcessLength, versatz);
    }
    static calcVerfahrweg(kette) {
        if (!kette.effektiveLaenge) {
            throw new Error(`KetteConfigurationBuilder.calcVerfahrweg: Invalid kette.effektiveLaenge`);
        }
        if (kette.langerWeg) {
            if (!kette.k2) {
                throw new Error(`KetteConfigurationBuilder.calcVerfahrweg: Invalid kette.k2`);
            }
            return echain_shared_articles_1.KetteCalculator.calcVerfahrwegWithLangerWeg(kette.effektiveLaenge, kette.k2, kette.versatz);
        }
        if (!kette.k) {
            throw new Error(`KetteConfigurationBuilder.calcVerfahrweg: Invalid kette.k`);
        }
        return echain_shared_articles_1.KetteCalculator.calcVerfahrweg(kette.effektiveLaenge, kette.k, kette.versatz);
    }
    static calcVerfahrwegJson(ketteJson) {
        if (!ketteJson.EffektiveLaenge) {
            throw new Error(`KetteConfigurationBuilder.calcVerfahrwegJson: Invalid ketteJson.EffektiveLaenge`);
        }
        const effektiveLaenge = echain_shared_quantities_1.Length.fromJson(ketteJson.EffektiveLaenge);
        const versatz = ketteJson.Versatz ? echain_shared_quantities_1.Length.fromJson(ketteJson.Versatz) : echain_shared_quantities_1.Length.mm(0);
        if (ketteJson.LangerWeg) {
            if (!ketteJson.K2) {
                throw new Error(`KetteConfigurationBuilder.calcVerfahrwegJson: Invalid ketteJson.K2`);
            }
            const k2 = echain_shared_quantities_1.Length.fromJson(ketteJson.K2);
            return echain_shared_articles_1.KetteCalculator.calcVerfahrwegWithLangerWeg(effektiveLaenge, k2, versatz);
        }
        else {
            if (!ketteJson.K) {
                throw new Error(`KetteConfigurationBuilder.calcVerfahrwegJson: Invalid ketteJson.K`);
            }
            const k = echain_shared_quantities_1.Length.fromJson(ketteJson.K);
            return echain_shared_articles_1.KetteCalculator.calcVerfahrweg(effektiveLaenge, k, versatz);
        }
    }
    static calcESkinVerfahrweg(kette) {
        if (!kette.effektiveLaenge) {
            throw new Error(`KetteConfigurationBuilder.calcESkinVerfahrweg: Invalid kette.effektiveLaenge`);
        }
        if (!kette.k) {
            throw new Error(`KetteConfigurationBuilder.calcESkinVerfahrweg: Invalid kette.k`);
        }
        const aeExcessLength = kette.getESkinAeExcessLength();
        return echain_shared_articles_1.KetteCalculator.calcESkinVerfahrweg(kette.effektiveLaenge, kette.k, kette.versatz, aeExcessLength);
    }
    static calcESkinVerfahrwegJson(ketteJson) {
        if (!ketteJson.EffektiveLaenge) {
            throw new Error(`KetteConfigurationBuilder.calcESkinVerfahrwegJson: Invalid ketteJson.EffektiveLaenge`);
        }
        if (!ketteJson.K) {
            throw new Error(`KetteConfigurationBuilder.calcESkinVerfahrwegJson: Invalid ketteJson.K`);
        }
        const aeExcessLength = Kette_1.Kette.fromJson(ketteJson).getESkinAeExcessLength();
        const effektiveLaenge = echain_shared_quantities_1.Length.fromJson(ketteJson.EffektiveLaenge);
        const versatz = ketteJson.Versatz ? echain_shared_quantities_1.Length.fromJson(ketteJson.Versatz) : echain_shared_quantities_1.Length.mm(0);
        const k = echain_shared_quantities_1.Length.fromJson(ketteJson.K);
        return echain_shared_articles_1.KetteCalculator.calcESkinVerfahrweg(effektiveLaenge, k, versatz, aeExcessLength);
    }
    static calcNumGlieder(kette) {
        if (!kette.laenge) {
            throw new Error(`KetteConfigurationBuilder.calcNumGlieder: Invalid kette.laenge`);
        }
        if (!kette.teilung) {
            throw new Error(`KetteConfigurationBuilder.calcNumGlieder: Invalid kette.teilung`);
        }
        const numGlieder = echain_shared_articles_1.KetteCalculator.calcNumGlieder(kette.laenge, kette.teilung);
        return KetteConfigurationBuilder.validateNumGlieder(kette, numGlieder);
    }
    static calcNumGliederJson(ketteJson) {
        if (!ketteJson.Laenge) {
            throw new Error(`KetteConfigurationBuilder.calcNumGlieder: Invalid ketteJson.Laenge`);
        }
        if (!ketteJson.Teilung) {
            throw new Error(`KetteConfigurationBuilder.calcNumGlieder: Invalid ketteJson.Teilung`);
        }
        const laenge = echain_shared_quantities_1.Length.fromJson(ketteJson.Laenge);
        const teilung = echain_shared_quantities_1.Length.fromJson(ketteJson.Teilung);
        const numGlieder = echain_shared_articles_1.KetteCalculator.calcNumGlieder(laenge, teilung);
        return KetteConfigurationBuilder.validateNumGliederJson(ketteJson, numGlieder);
    }
    static validateNumGlieder(kette, numGlieder) {
        if (kette.ungeradeAnzahlGlieder) {
            return numGlieder % 2 === 0 ? numGlieder + 1 : numGlieder;
        }
        return numGlieder;
    }
    static validateNumGliederJson(ketteJson, numGlieder) {
        if (ketteJson.SerieRef && ketteJson.UngeradeAnzahlGlieder) {
            return numGlieder % 2 === 0 ? numGlieder + 1 : numGlieder;
        }
        return numGlieder;
    }
}
exports.KetteConfigurationBuilder = KetteConfigurationBuilder;
//# sourceMappingURL=KetteConfigurationBuilder.js.map